import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../context';
import DataTable from '../../components/tables/DataTable';
import StatCard from '../../components/StatCard';
import ExportButton from '../../components/ExportButton';
import DateRangePicker from '../../components/DateRangePicker';
import { getLoyaltyReport } from '../../utils/queries';

export default function LoyaltyReport() {
	const { activeStoreId } = useContext(MyContext);
	const [range, setRange] = useState({});
	const [report, setReport] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		getLoyaltyReport({
			storeId: activeStoreId || undefined,
			dateFrom: range.from || undefined,
			dateTo: range.to || undefined,
		}).then((result) => {
			if (result?.success) setReport(result.data);
			setLoading(false);
		});
	}, [activeStoreId, range.from, range.to]);

	const columns = [
		{ key: 'program_name', header: 'Program' },
		{ key: 'redemptions', header: 'Redemptions' },
		{ key: 'points', header: 'Points Redeemed' },
	];

	return (
		<div className='py-8 pr-8'>
			<div className='flex items-center justify-between mb-6'>
				<h1 className='text-2xl font-light tracking-tight'>Loyalty Redemption Report</h1>
				<ExportButton
					fileName='loyalty-redemption-report'
					sections={[
						{
							data: report?.rows || [],
							columns: columns.map((c) => c.header),
							columnKeys: columns.map((c) => c.key),
							columnTypes: ['text', 'number', 'number'],
						},
					]}
				/>
			</div>

			<div className='mb-6'>
				<label>Date Range</label>
				<DateRangePicker value={range} onChange={setRange} className='w-72' />
			</div>

			{loading || !report ? (
				<div className='text-sm text-gray-400'>Loading...</div>
			) : (
				<>
					<div className='grid grid-cols-4 gap-4 mb-8'>
						<StatCard label='Total Redemptions' value={report.summary.total_redemptions} />
						<StatCard label='Total Points Redeemed' value={report.summary.total_points_redeemed} />
					</div>

					<DataTable columns={columns} data={report.rows} emptyHeading='No redemptions in range' />
				</>
			)}
		</div>
	);
}
